<div class="bg-no-repeat bg-left sm:bg-center bg-cover py-[60px] md:py-[80px] lg:py-[100px]"
     [style.background-image]="imgMosaico ? 'url(' + imgMosaico + ')' : 'none'">

    <div class="container mx-auto px-[12px] 2xl:px-0">

        <!-- Header -->
        <div class="mb-[40px] md:mb-[50px] lg:mb-[60px]">
            <span class="block uppercase font-medium text-[13px] md:text-[14px] text-negro tracking-widest mb-[10px] md:mb-[12px]"
                  data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
                {{ texts?.cards_section?.title }}
            </span>
            <h2 class="font-bold font-serif text-[28px] md:text-[34px] lg:text-[40px] xl:text-[46px] leading-[1.2]"
                data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
                <span class="text-Navy block">{{ subtitleParts[0] }}</span>
                <span class="text-Teal block">{{ subtitleParts[1] }}</span>
            </h2>
        </div>

        <!-- Cards -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[20px] md:gap-[24px] mb-[50px] md:mb-[60px]">
            <div *ngFor="let card of texts?.cards_section?.cards; let i = index"
                 class="bg-white border border-[#e2eaf3] rounded-[12px] px-[24px] pt-[28px] pb-[24px] flex flex-col justify-between"
                 [class.border-[#9abcde]]="i === (texts?.cards_section?.cards?.length ?? 0) - 1"
                 data-aos="fade-up" data-aos-duration="500" [attr.data-aos-delay]="100 + i * 100">

                <div>
                    <h3 class="font-bold text-Navy text-[18px] md:text-[20px] lg:text-[22px] leading-[1.3] mb-[12px] md:mb-[16px]">
                        {{ card.title }}
                    </h3>
                    <p class="text-[14px] md:text-[15px] text-[#4c4c4c] leading-[1.7]">
                        {{ card.description }}
                    </p>
                </div>

                <div class="border-t border-[#e2eaf3] mt-[50px] md:mt-[100px]">
                    <span class="font-bold text-Navy text-[28px] md:text-[32px] lg:text-[36px] font-serif">
                        {{ card.number }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Footer description -->
        <div class="text-center pt-[24px] md:pt-[30px]"
             data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
            <p class="font-semibold text-[13px] md:text-[14px] lg:text-[15px] tracking-widest uppercase">
                <span class="text-negro">{{ descriptionParts[0] }}</span>
                <span class="text-Navy">|{{ descriptionParts[1] }}</span>
            </p>
        </div>

    </div>
</div>
